import classNames from 'classnames';
import * as React from 'react';
import { Link }   from 'react-router-dom';

import type { OfferTagsProps } from './offer-tags.props';

const OfferTags: React.FC<OfferTagsProps> = function(props) {
  const {
          discountPercent,
          tags = [],
        } = props;

  const discount  = React.useMemo(() => {
    if (!discountPercent) {
      return;
    }

    return parseInt(discountPercent);
  }, [discountPercent]);
  const className = React.useMemo(() => {
    if (!discount) {
      return;
    }

    return classNames('blue', {
      green:  discount <= 10,
      orange: 10 < discount && discount <= 15,
      red:    15 < discount && discount <= 20,
    });
  }, [discount]);

  if (!discount && !tags.length) {
    return null;
  }

  return (
    <div
      className={'tags'}
      onClick={(event) => {
        event.stopPropagation();
      }}
    >
      {tags
        .sort((a, b) => {
          return b.priority - a.priority;
        })
        .map((tag, index) => {
          const style = tag.isColorEnabled
            ? {
              backgroundColor: `${tag.tagColor}99`,
              border:          `1px solid ${tag.tagColor}`,
              color:           tag.tagTextColor,
            }
            : {};

          if (typeof tag.link === 'string' && tag.link.length > 0) {
            return (
              <Link
                className={'tag'}
                key={index}
                style={style}
                target={'_blank'}
                to={tag.link}
              >{tag.label}</Link>
            );
          }

          return (
            <span
              className={'tag'}
              key={index}
              style={style}
            >{tag.label}</span>
          );
        })
      }
      {!!discount && <span className={className}>-{discount}%</span>}
    </div>
  );
};

export default OfferTags;